import { RootState } from '../../store';

export const getIsActiveZoomerSelector = (state: RootState) => state.photoZoomReducer.isActive;
export const getSrcZoomerSelector = (state: RootState) => state.photoZoomReducer.src;
